'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Magnifier = function (_React$PureComponent) {
  _inherits(Magnifier, _React$PureComponent);

  function Magnifier() {
    _classCallCheck(this, Magnifier);

    return _possibleConstructorReturn(this, (Magnifier.__proto__ || Object.getPrototypeOf(Magnifier)).apply(this, arguments));
  }

  _createClass(Magnifier, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: this.props.size,
          height: this.props.size,
          viewBox: '0 0 128 128'
        },
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('path', {
            fill: '#231F20',
            d: 'M104.688 110.964a5.512 5.512 0 0 1-7.767.215L79.727 95.513c-15.955 12.712-39.023 10.928-52.834-4.087-13.81-15.014-13.665-38.15.333-52.99 13.998-14.84 37.087-16.335 52.881-3.423 15.794 12.911 18.921 35.836 7.161 52.506l17.205 15.666a5.512 5.512 0 0 1 .215 7.78z',
            opacity: '.15'
          }),
          _react2.default.createElement('circle', {
            cx: '55.544',
            cy: '60.322',
            r: '38.837',
            fill: '#989EA0',
            fillRule: 'nonzero',
            transform: 'rotate(-46.62 55.544 60.322)'
          }),
          _react2.default.createElement('path', {
            fill: '#989EA0',
            d: 'M104.688 106.192a5.512 5.512 0 0 1-7.767.214L79.727 90.74c-2.195-2.076-.549-4.427 1.527-6.622 0 0 3.83-3.448 6.026-1.372L104.46 98.4a5.512 5.512 0 0 1 .227 7.792z'
          }),
          _react2.default.createElement('path', {
            fill: '#B7C1C4',
            d: 'M104.688 101.419a5.512 5.512 0 0 1-7.767.215L79.727 85.908a5.512 5.512 0 0 1-.215-7.768 5.512 5.512 0 0 1 7.768-.215L104.46 93.58a5.512 5.512 0 0 1 .227 7.839z'
          }),
          _react2.default.createElement('circle', {
            cx: '55.547',
            cy: '55.54',
            r: '38.837',
            fill: '#B7C1C4',
            fillRule: 'nonzero',
            transform: 'rotate(-46.62 55.547 55.54)'
          }),
          _react2.default.createElement('circle', {
            cx: '55.544',
            cy: '55.548',
            r: '29.59',
            fill: '#5DBABA',
            fillRule: 'nonzero',
            transform: 'rotate(-46.62 55.544 55.548)'
          }),
          _react2.default.createElement('path', {
            fill: '#8FE5E5',
            d: 'M75.3 38.468c11.813 11.156 11.992 26.631 1.194 38.073-10.798 11.443-29.15 11.67-40.95.513-11.8-11.156-11.991-26.63-1.193-38.073 10.798-11.443 29.15-11.67 40.95-.513z'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            d: 'M62.223 46.856c-7.91-5.56-22.526-6.11-16.573-11.479 5.56-5.011 16.037-4.546 23.935 1.014 7.899 5.56 10.464 12.994 8.352 21.68-1.944 7.768-7.803-5.655-15.714-11.215z',
            opacity: '.5'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M89.666 47.93a1.253 1.253 0 0 1-1.193-.943 15.57 15.57 0 0 0-.262-.943 1.25 1.25 0 1 1 2.386-.74c.167.537.19.645.298 1.074a1.253 1.253 0 0 1-1.193 1.563l-.036-.012z',
            opacity: '.3'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M87.888 42a1.193 1.193 0 0 1-1.193-.74c-3.985-8.961-13.41-16.896-21.859-18.447a1.256 1.256 0 1 1 .454-2.47c9.187 1.695 19.4 10.238 23.744 19.879a1.253 1.253 0 0 1-1.193 1.765l.047.012z',
            opacity: '.5'
          })
        )
      );
    }
  }]);

  return Magnifier;
}(_react2.default.PureComponent);

Magnifier.defaultProps = {
  size: 64
};

Magnifier.propTypes = {
  size: _propTypes2.default.number
};

exports.default = Magnifier;